/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load Outbrain Ads functions
 * */

(function (pmw, $, undefined) {

	pmw.loadOutbrainPixel = () => {

		const outbrainId = pmwDataLayer.pixels.outbrain.advertiser_id

		try {

			// @formatter:off
			!function(_window, _document) {
				var OB_ADV_ID = outbrainId;
				if (_window.obApi) {
					var toArray = function(object) {
						return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
					};
					_window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));
					return;
				}
				var api = _window.obApi = function() {
					api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
				};
				api.version = '1.1';
				api.loaded = true;
				api.marketerId = OB_ADV_ID;
				api.queue = [];
				var tag = _document.createElement('script');
				tag.async = true;
				tag.src = '//amplify.outbrain.com/cp/obtp.js';
				tag.type = 'text/javascript';
				var script = _document.getElementsByTagName('script')[0];
				script.parentNode.insertBefore(tag, script);
			}(window, document);

			obApi('track', 'PAGE_VIEW');
			// @formatter:on

			pmwDataLayer.pixels.outbrain.loaded = true

		} catch (e) {
			console.error(e)
		}
	}

	/**
	 * Check if the Outbrain pixel can be fired
	 *
	 * @return {boolean}
	 */
	pmw.canFireOutbrainEvent = () => {

		if (!pmwDataLayer?.pixels?.outbrain?.loaded) return false

		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Check if the Outbrain pixel can not be fired
	 *
	 * @return {boolean}
	 */
	pmw.canNotFireOutbrainEvent = () => {
		return !pmw.canFireOutbrainEvent()
	}

}(window.pmw = window.pmw || {}, jQuery));
